export default {
    'country.CN': 'China',
    'country.US': 'United States',
    'country.JP': 'Japan',
    'country.GB': 'United Kingdom',
    'country.DE': 'Germany',
    'country.FR': 'France',
    'country.IN': 'India',
    'country.BR': 'Brazil',
    'country.RU': 'Russia',
    'country.KR': 'South Korea',
    'country.select.placeholder': 'Please select country',
    'country.phone.code': 'Code: '
}